module.exports = __webpack_public_path__ + "static/media/menuIcon.1e2fd7e3.svg";